/* @vite-ignore */
import React from 'react';
import { lazy, Suspense } from 'react';

export function lazyLoadRoutes(componentName: string) {
  const LazyComponent = lazy(() => import(`../screens/${componentName}/index.tsx`));
  return React.createElement(Suspense, null, React.createElement(LazyComponent, null));
}
